import CompanyInvoicesTableView from './companyInvoicesTableView';

export default CompanyInvoicesTableView;
